module.exports = __webpack_public_path__ + "img/haft-poznan-05.9cccb8ea.jpg";